var map = {
	"./male/bottom/colorful/running/1.svg": 128,
	"./male/bottom/colorful/running/2.svg": 129,
	"./male/bottom/colorful/running/3.svg": 130,
	"./male/bottom/colorful/running/4.svg": 131,
	"./male/bottom/colorful/running/5.svg": 132,
	"./male/bottom/colorful/running/6.svg": 133,
	"./male/bottom/colorful/running/7.svg": 134,
	"./male/bottom/colorful/running/8.svg": 135,
	"./male/bottom/colorful/walking/1.svg": 136,
	"./male/bottom/colorful/walking/2.svg": 137,
	"./male/bottom/colorful/walking/3.svg": 138,
	"./male/bottom/colorful/walking/4.svg": 139,
	"./male/bottom/colorful/walking/5.svg": 140,
	"./male/bottom/colorful/walking/6.svg": 141,
	"./male/bottom/colorful/walking/7.svg": 142,
	"./male/bottom/colorful/walking/8.svg": 143,
	"./male/head/colorful/1.svg": 144,
	"./male/head/colorful/10.svg": 145,
	"./male/head/colorful/2.svg": 146,
	"./male/head/colorful/3.svg": 147,
	"./male/head/colorful/4.svg": 148,
	"./male/head/colorful/5.svg": 149,
	"./male/head/colorful/6.svg": 150,
	"./male/head/colorful/7.svg": 151,
	"./male/head/colorful/8.svg": 152,
	"./male/head/colorful/9.svg": 153,
	"./male/top/colorful/running/1.svg": 154,
	"./male/top/colorful/running/2.svg": 155,
	"./male/top/colorful/running/3.svg": 156,
	"./male/top/colorful/running/4.svg": 157,
	"./male/top/colorful/running/5.svg": 158,
	"./male/top/colorful/running/6.svg": 159,
	"./male/top/colorful/running/7.svg": 160,
	"./male/top/colorful/running/8.svg": 161,
	"./male/top/colorful/walking/1.svg": 162,
	"./male/top/colorful/walking/2.svg": 163,
	"./male/top/colorful/walking/3.svg": 164,
	"./male/top/colorful/walking/4.svg": 165,
	"./male/top/colorful/walking/5.svg": 166,
	"./male/top/colorful/walking/6.svg": 167,
	"./male/top/colorful/walking/7.svg": 168,
	"./male/top/colorful/walking/8.svg": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;